import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { MetaLayerDefinition, useLayers } from '@agissc/ktag-map';
import { BasemapCategory } from './Contracts';

const basemapCategories: Record<string, BasemapCategory> = {
  color: {
    label: 'basemap_color',
    defaultItem: 'base_landeskarten_farbig::topicmaps.geo.ag.ch',
    items: ['base_landeskarten_farbig::topicmaps.geo.ag.ch'],
  },
  grayscale: {
    label: 'basemap_grayscale',
    defaultItem: 'base_landeskarten_sw::topicmaps.geo.ag.ch',
    items: ['base_landeskarten_sw::topicmaps.geo.ag.ch'],
  },
  aerial: {
    label: 'basemap_aerial',
    defaultItem: 'base_ortho_aktuell::topicmaps.geo.ag.ch',
    items: [],
  },
};

const fetchBasemapCategories = (data: Record<string, MetaLayerDefinition>) => {
  const aerialItems = Object.keys(data).filter((key) => key.includes('base_ortho'));

  return {
    ...basemapCategories,
    aerial: {
      ...basemapCategories.aerial,
      items: aerialItems,
    },
  };
};

const useBasemapCategories = () => {
  const layers = useLayers();

  const dataKey = useMemo(() => {
    return layers.data ? Object.keys(layers.data).sort().join(',') : null;
  }, [layers.data]);

  return useQuery<Record<string, BasemapCategory>>({
    queryKey: ['basemapCategories', dataKey],
    queryFn: () => fetchBasemapCategories(layers.data),
    enabled: !!layers.data,
    gcTime: Infinity,
    staleTime: Infinity,
  });
};

export default useBasemapCategories;
